<div class="md-container">
  <div class="md-toolbar">
    <div class="md-toolbar-left">
      <div class="md-toolbar-group" aria-label="标题格式">
        <button
          class="md-toolbar-item md-toolbar-item--text"
          type="button"
          (click)="insertHeader(1)"
          aria-label="一级标题"
          title="一级标题"
        >
          H1
        </button>
        <button
          class="md-toolbar-item md-toolbar-item--text"
          type="button"
          (click)="insertHeader(2)"
          aria-label="二级标题"
          title="二级标题"
        >
          H2
        </button>
        <button
          class="md-toolbar-item md-toolbar-item--text"
          type="button"
          (click)="insertHeader(3)"
          aria-label="三级标题"
          title="三级标题"
        >
          H3
        </button>
      </div>

      <span class="md-toolbar-separator" aria-hidden="true"></span>

      <div class="md-toolbar-group" aria-label="文字格式">
        <button
          class="md-toolbar-item"
          type="button"
          (click)="insertBold()"
          aria-label="加粗"
          title="加粗"
        >
          <mat-icon>format_bold</mat-icon>
        </button>
        <button
          class="md-toolbar-item"
          type="button"
          (click)="insertItalic()"
          aria-label="斜体"
          title="斜体"
        >
          <mat-icon>format_italic</mat-icon>
        </button>
      </div>

      <span class="md-toolbar-separator" aria-hidden="true"></span>

      <div class="md-toolbar-group" aria-label="代码与媒体">
        <button
          class="md-toolbar-item"
          type="button"
          (click)="insertInlineCodeBlock()"
          aria-label="行内代码"
          title="行内代码"
        >
          <mat-icon>code</mat-icon>
        </button>
        <button
          class="md-toolbar-item md-toolbar-item--code-block"
          type="button"
          (click)="insertCodeBlock()"
          aria-label="代码块"
          title="代码块"
        >
          {{ "{ }" }}
        </button>
        <button
          class="md-toolbar-item"
          type="button"
          (click)="selectFile()"
          aria-label="上传图片"
          title="上传图片"
        >
          <mat-icon>image</mat-icon>
        </button>
      </div>
    </div>
    <div class="md-toolbar-right">
      <span class="md-toolbar-hint">自动保存已开启</span>
      <ng-content select="[slotToolbarRight]"></ng-content>
    </div>
  </div>
  <div class="md-main">
    <div (paste)="handlePaste($event)" class="md-editor-wrapper">
      <div class="md-pane-header">
        <span>Markdown</span>
        <span class="md-pane-header__hint">编辑</span>
      </div>
      <ngx-monaco-editor
        class="md-editor"
        [options]="editorOptions"
        [ngModel]="code"
        (ngModelChange)="onCodeChange($event)"
        (init)="onEditorInit($event)"
      ></ngx-monaco-editor>
    </div>

    <div class="md-preview-wrapper">
      <div class="md-pane-header">
        <span>实时预览</span>
        <span class="md-pane-header__hint">Preview</span>
      </div>
      <div
        #preview
        class="md-preview"
        [ngClass]="theme"
        [innerHTML]="html$ | async"
      ></div>
    </div>
  </div>
</div>
